import { AnalyticsInsightsPopupController } from './analytics-insights-popup.controller'

function analyticsInsightsPopup () {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      params: '<',
      icon: '<'
    },
    templateUrl: '/analytics/directives/analytics-insights-popup/analytics-insights-popup-directive.html?$$REVISION$$',
    controller: AnalyticsInsightsPopupController
  }
}

export { analyticsInsightsPopup }
